<template>
    <v-dialog v-model="dialog" persistent fullscreen>
        <plot-list :item-definition="itemDefinition" fullscreen-mode></plot-list>
    </v-dialog>
</template>

<script>
    import PlotList from "./PlotList.vue";
    export default {
        name: 'PlotListFS',
        components: {
            PlotList
        },
        props: {
            itemDefinition: {type: Object, default: null},
        },
        data() {
            return {
                dialog: true
            }
        },
    }
</script>
